/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Preview_HideInputs */

const cs_builder_preview_hide = /** @type {(inputs: Builder_Preview_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrýt náhled`)
};

const en_builder_preview_hide = /** @type {(inputs: Builder_Preview_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide preview`)
};

/**
* | output |
* | --- |
* | "Hide preview" |
*
* @param {Builder_Preview_HideInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_preview_hide = /** @type {((inputs?: Builder_Preview_HideInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Preview_HideInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_preview_hide(inputs)
	return cs_builder_preview_hide(inputs)
});